const state = {
  conference: {
    isCloak: true, // true false
    options: {
      items: [{
        words: '查看大会',
        href: 'http://2017.qconshanghai.com/?utm_source=geekbang&utm_campaign=8&utm_medium=banner'
      }, {
        words: '观看直播',
        href: 'https://live.geekbang.org'
      }
        // {
        //   words: '观看视频'
        // }
      ]
    }
  },
  isMobile: undefined,
  divT: undefined
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js